<template>
  <q-layout id="clear-layout">
    <q-page-container class="absolute-center">
      <router-view />
    </q-page-container>
  </q-layout>
</template>
